export function hasBusinessBilling(source) {
  const metadata = source?.metadata ?? {};
  const billingMode = String(source?.billing_mode ?? metadata.billing_mode ?? '').toLowerCase();

  return billingMode === 'business'
    || String(source?.billing_is_business ?? metadata.billing_is_business ?? '').toLowerCase() === 'true';
}
